import React, { useState, useEffect } from 'react';
import { getAccessToken } from '../../utils/auth';
import { LoginAuth } from '../../components/login/LoginAuth';
import DataTable from 'react-data-table-component';
import {
	Form,
	Button,
	Row,
	Input,
	FormGroup,
	Label,
	Table,
} from 'reactstrap';
import { ToastContainer, toast } from 'react-toastify';
import {
	initialDificultadData,
	initialArrayDificultadData,
} from '../../api/Dificultad/dificultadModel';
import {
	getDificultadApi,
	getDificultadByIdApi,
	createDificultadApi,
	editDificultadApi,
	deleteDificultadApi,
} from '../../api/Dificultad/dificultad';
import { InputCheckbox } from '../../components/Inputs/InputCheckbox';
import './Dificultad.scss';
import Tooltip from '@mui/material/Tooltip';
import Notificacion from '../../components/snackbar/Notificacion';
import { 
	Container,
	Box, 
	FormControl,
	TextField,
	IconButton
} from '@mui/material';
import Grid from '@mui/material/Grid';
import CancelIcon from '@mui/icons-material/Cancel';
import AddIcon from '@mui/icons-material/Add';
import '../../scss/abmEstilos.scss';
import Loading from '../../components/loading/Loading';
import SaveIcon from '@mui/icons-material/Save';

export default function Dificultad() {
	const [isCreate, setIsCreate] = useState(true);
	const [isAnulado, setIsAnulado] = useState(true);
	const [isDisable, setIsDisable] = useState('');

	const [dificultadData, setDificultadData] = useState(initialDificultadData);

	const [arrayDificultadData, setArrayDificultadData] = useState(
		initialArrayDificultadData
	);

	const handleChangeDificultad = event => {
		let texto = event.target.value;
		setIsDisable(texto);
		setDificultadData({
			...dificultadData,
			[event.target.name]: event.target.value,
		});
	};

	const handleEditDificultad = event => {
		let id = event.target.dataset.id;
		let dificultad = arrayDificultadData.filter(el => el.id == id);
		setIsDisable(dificultad);
		if (dificultad.length) {
			setDificultadData(dificultad[0]);
			setIsCreate(false);

			if (dificultad[0].anulado == 'N') {
				setIsAnulado(true);
			} else {
				setIsAnulado(false);
			}
		}
	};

	const handleSubmitDificultad = event => {
		event.preventDefault();
		isCreate ? createDificultad() : editDificultad();
	};

	useEffect(() => {
		getArrayDificultad();
	}, []);

	const columns = [
		{
			name: 'Dificultades',
			selector: row => row.descripcion ? ( row.descripcion) : (''),
			cell: row =>
				row.descripcion ? (
					<div className="dataTableText">
						{row.descripcion}
					</div>
				) : (
					''
				),
			sortable: true,
			maxWidth: 200,
			minWidth: 140,
			width: 200,
			wrap: true,
		},
		{
			name: 'Estado',
			selector: row => row.anulado,
			sortable: true,
			cell: obj => {
				return (
					<div className="botonesTabla">
						{obj.anulado == 'N' ? (
							<div className="abmCampoVisible">
								<span className="material-symbols-rounded abmIcoVisi">
									visibility
								</span>
								Habilitado
							</div>
						) : (
							<div className="abmCampoDeshabilitar">
								<span className="material-symbols-rounded  abmIcoVisiOff">
									visibility_off
								</span>
								Deshabilitado
							</div>
						)}
					</div>
				);
			},
			maxWidth: 200,
			minWidth: 140,
			width: 200,
			wrap: true,
		},
		{
			cell: obj => {
				return (
					<div className="botonesTabla">
						<Tooltip title="Editar" placement="top" arrow>
							<IconButton
								data-id={obj.id ? obj.id : ''}
								className="material-symbols-rounded icoAbmEditar"
								onClick={handleEditDificultad}
							>
								mode_edit
							</IconButton>
						</Tooltip>
					</div>
				);
			},
			right: true,
			ignoreRowClick: true,
			allowOverflow: true,
		},
	];

	const handleChangeAnulado = event => {
		let anulado = event.target.checked;
		setIsAnulado(anulado);
	};

	const handleClickCancelar = () => {
		setIsDisable('');
		clear();
	};

	const clear = () => {
		setIsDisable('');
		setIsCreate(true);
		setIsAnulado(true);
		setDificultadData(initialDificultadData);
	};

	const [OpenNoti, setOpenNoti] = React.useState(false);

	const notiConfigIni = {
		titulo: '',
		mensaje: '',
		estilo: 'notiSuccessFilled',
		tiempo: 4000,
		vertical: 'bottom',
		horizontal: 'center',
	};

	const [notiConfig,setNotiConfig] = useState(notiConfigIni);

	const _fieldObligatorio = () => {
		return <b style={{ color: 'red' }}>*</b>;
	};

	const emptyColumn = [
		{
			name: 'Dificultades',
			cell: obj => {
				return <span>Sin dificultades creadas.</span>;
			},
			left: true,
			ignoreRowClick: true,
			allowOverflow: true,
		},
	];

	const [dataTest, setDataTest] = useState([
		{
			descripcion: 'Sin dificultades creadas.',
		},
	]);

	const [openLoad, setOpenLoad] = React.useState(false);

	const handleCloseLoad = () => {
		setOpenLoad(false);
	};

	const handleOpenLoad = () => {
		setOpenLoad(true);
	};

	if (getAccessToken()) {
		return (
			<Container className="contenedor">
				<div className="textoContenido">
					<h1 className="tituloContenido">Dificultades</h1>
					<p className="parrafoContenido">
						Creá y configurá las dificultades que formarán parte del contenido.
					</p>
				</div>

				<div className="textoContenido">
					<h2 className="subtituloContenido">Crear dificultad</h2>

					<Box sx={{ flexGrow: 1 }}>
						<Grid container spacing={2}>
							<Grid item xs={8}>
								<FormControl className="descripAbm">
									<TextField
										id="descripcion"
										name="descripcion"
										label={
											<span style={{ fontFamily: 'Roboto' }}>
												Nombre de la dificultad {_fieldObligatorio()}
											</span>
										}
										variant="outlined"
										inputProps={{ maxLength: 255 }}
										type="text"
										onChange={handleChangeDificultad}
										value={dificultadData.descripcion || ''}
									/>
								</FormControl>
							</Grid>
							<Grid className='' item xs={4}>
								<div className="seccionInput">
									<InputCheckbox
										isAnulado={isAnulado}
										handleChangeAnulado={handleChangeAnulado}
										isDisable={!isDisable}
									></InputCheckbox>
								</div>
								<div className="btnContentAbm">
									<Button
										className="btnCrearAbm"
										disabled={!isDisable}
										onClick={handleSubmitDificultad}
									>
										{isCreate ?
										<AddIcon  className='btnIcoAbm'/>
										:
										<SaveIcon className='btnIcoAbm'/>
										}
										{isCreate ? 'Crear' : 'Guardar'}
									</Button>
									<Button
										className="btnAbmCancel"
										onClick={handleClickCancelar}
										disabled={isCreate ? !isDisable : false}
									>
										<CancelIcon  className='btnIcoAbm'/>
										Cancelar
									</Button>
								</div>
							</Grid>
						</Grid>
					</Box>
				</div>

				<h2 className="subtituloContenido listado">Listado de dificultades</h2>

				<DataTable
					columns={columns}
					className="dataTableContainer"
					data={arrayDificultadData ? arrayDificultadData : ''}
					direction="auto"
					fixedHeaderScrollHeight="300px"
					responsive
					subHeaderAlign="right"
					subHeaderWrap
					noDataComponent={
						<DataTable
							columns={emptyColumn}
							className="dataTableContainer"
							data={dataTest ? dataTest : ''}
							direction="auto"
							fixedHeaderScrollHeight="300px"
							responsive
							subHeaderAlign="right"
							subHeaderWrap
						/>
					}
					paginationPerPage={5}
					pagination
					paginationComponentOptions={{
						rowsPerPageText: 'Registros por página:',
						rangeSeparatorText: 'de',
					}}
					paginationRowsPerPageOptions={[5, 10, 15, 20, 50]}
				/>

				<Notificacion open={OpenNoti} setState={setOpenNoti} config={notiConfig} />

				<Loading
					bg="bgLoadingWhite"
					open={openLoad}
				/>
			</Container>
		);
	}

	async function getArrayDificultad() {
		try {
			handleOpenLoad();
			let dificultades = await getDificultadApi();
			setArrayDificultadData(dificultades);
			handleCloseLoad();
		} catch (error) {
			console.log('🚀 ~ file: Example.js ~ line 55 ~ getUser ~ error', error);
		}
	}

	async function createDificultad() {
		try {
			delete dificultadData.id;
			let descripcion = dificultadData.descripcion.trim();
			let anulado = isAnulado ? 'N' : 'S';

			let dificultad = await createDificultadApi({ descripcion, anulado });
			setArrayDificultadData([...arrayDificultadData, dificultad]);
			clear();
			notiConfig.estilo = 'notiSuccessFilled';
			notiConfig.mensaje = "Datos creados con éxito";
			setOpenNoti(true);
		} catch (error) {
			console.log(error);

			let msj = await error.json();

			if (error.status == 422) {
				notiConfig.estilo = 'notiDangerFilled';
				notiConfig.mensaje = msj.violations[0].message;
				setOpenNoti(true);
			}
		}
	}

	async function editDificultad() {
		try {
			console.log('🚀 ~ file: Proyecto.js:237 ~ editMaterial ~ editMaterial');
			let id = dificultadData.id;
			dificultadData.anulado = isAnulado ? 'N' : 'S';
			dificultadData.descripcion = dificultadData.descripcion.trim();
			await editDificultadApi(id, dificultadData);
			clear();
			setIsCreate(true);
			setDificultadData(initialDificultadData);
			getArrayDificultad();
			notiConfig.estilo = 'notiSuccessFilled';
			notiConfig.mensaje = "Datos modificados con éxito";
			setOpenNoti(true);
		} catch (error) {
			console.log('🚀 ~ file: Material.js:187 ~ editMaterial ~ error', error);
			
			let msj = await error.json();

			if (error.status == 422) {
				notiConfig.estilo = 'notiDangerFilled';
				notiConfig.mensaje = msj.violations[0].message;
				setOpenNoti(true);
			}
		}
	}

	return (
		<>
			<LoginAuth></LoginAuth>
		</>
	);
}
